import React, { useCallback, useRef } from 'react';

export const useInfiniteScroll = <T>(
  hasNext: boolean | undefined,
  setPageNumber: React.Dispatch<React.SetStateAction<number>>
) => {
  const observer = useRef<any>();

  const lastElementRef = useCallback(
    (node: T) => {
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNext) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [hasNext]
  );

  return { lastElementRef };
};
